/**
 * Reducers required at store boot (login + shell).
 * Feature domains are loaded later via injectReducerGroup().
 */
import auth from './AuthReducers';
import layout from './LayoutReducer';
import rest from './RestReducer';
import global from './GlobalReducers';
import branch from './BranchReducer';
import entities from './EntityReducer';
import modules from './ModulesReducer';
import translation from './TranslationsReducer';
import notifications from './NotificationsReducer';
import messages from './MessagesReducer';
import navigation from './NavigationReducer';
import user from './UsersReducer';
import loyalty from './LoyaltyReducer';
import zone from './DeliveryZonesReducers';
import qr from './QRReducers';

export const coreReducerMap = {
  auth,
  layout,
  rest,
  global,
  branch,
  entities,
  modules,
  translation,
  notifications,
  messages,
  navigation,
  user,
  loyalty,
  zone,
  qr,
};
